import React from 'react';

import clockIcon from '_images/clock-icon.svg';
import locationIcon from '_images/location-icon.svg';
import oneshiftByCarousellLogo from '_images/oneshift-by-carousell-logo.png';
import oneshiftByCarousellLogoDark from '_images/oneshift-by-carousell-logo-dark-mode.png';
import phoneIcon from '_images/phone-icon.svg';
import mailIcon from '_images/mail-icon.svg';
import { Link } from 'gatsby';

export default function BusinessInfoSection({ theme = 'light' }) {
  const isDark = theme === 'dark';

  return (
    <div className="flex flex-col gap-y-4 md:gap-y-8 lg:grid lg:grid-cols-4 xl:flex xl:flex-col xl:gap-y-8">
      <div className="md:col-span-1 xl:col-auto">
        <img
          src={isDark ? oneshiftByCarousellLogoDark : oneshiftByCarousellLogo}
          className="h-[44px]"
          alt="OneShift Logo"
        />
      </div>
      <div className="col-span-3 xl:col-auto text-sm">
        <h4 className={`font-semibold mb-0 leading-relaxed ${isDark ? 'text-white' : ''}`}>Contact us</h4>
        <ul className={`mb-0 ${isDark ? 'text-gray-400' : 'text-content-secondary'} xl:max-w-[328px] flex flex-col gap-y-1 mt-2`}>
          <li className="flex gap-x-2 mb-1">
            <div className="w-4 flex-shrink-0 pt-1">
              <img src={locationIcon} alt="Location" className={isDark ? 'brightness-0 invert' : ''} />
            </div>

            <p className="mb-0 leading-relaxed">
            <a href="https://maps.app.goo.gl/YcqTNvZ2McHPysCf7" className="text-inherit" target="_blank">Showroom: 5 Toa Payoh West, #01-00, Motorway Building, Singapore 318877</a>
            </p>
          </li>
          <li className="flex gap-x-2 mb-1">
            <div className="w-4 flex-shrink-0 pt-1">
              <img src={clockIcon} alt="Clock" className={isDark ? 'brightness-0 invert' : ''} />
            </div>
            <p className="mb-0 leading-relaxed">
              Daily: 10:00 am - 6:00 pm
            </p>
          </li>
          <li className="flex gap-x-2 mb-1">
            <div className="w-4 flex-shrink-0 pt-1">
              <img src={phoneIcon} alt="Phone" className={isDark ? 'brightness-0 invert' : ''} />
            </div>
            <a href="tel://+6565335878" className="text-inherit"><p className="mb-0 leading-relaxed">6533 5878</p></a>
          </li>
          <li className="flex gap-x-2 mb-1">
            <div className="w-4 flex-shrink-0 pt-1">
              <img src={mailIcon} alt="Email" className={isDark ? 'brightness-0 invert' : ''} />
            </div>
            <a href="mailto:autos.assist@carousell.com" className="text-inherit"><p className="mb-0 leading-relaxed">autos.assist@carousell.com</p></a>
          </li>
        </ul>
      </div>
    </div>
  );
}
